import { createReducer, on } from '@ngrx/store';
import { checkUserExist, restoreDefault } from '../actions/sign-up.actions';

export const checkUserExitFeatureKey = 'CheckUserExist';

export interface State {
  isRegistered: boolean | null;
  err: any;
}

export const initialState: State = {
  isRegistered: false,
  err: null,
};

export const reducer = createReducer(
  initialState,
  on(checkUserExist['[checkUserExist]CheckUserExistSuccess'], (state, { data }) => {
    return {
      ...state,
      userData: data.userData,
      isRegistered: Object.keys(data?.coduluz)?.length == 0 && data?.errors?.length == 0,
      err: data.errors,
      errCoduluz: data?.coduluz,
    };
  }),
  on(restoreDefault['[restoreDefault]RestoreDefault'], (state) => {
    return {
      ...state,
      userData: {},
      isRegistered: false,
      err: null,
      errCoduluz: null,
    };
  }),
  on(checkUserExist['[checkUserExist]UpdateUserData'], (state, action) => {
    return {
      ...state,
      userData: action.data,
    };
  })
);
